import { useEffect, useState } from "react";
import { apiGet } from "../../Api/Client.js";
import { canSeeLabel, runsCompany } from "../../Services/pageAccess.js";

const ASK_EVERY_MS = 60000;

// A yes/no answer from the server, asked now and then every minute while `enabled`. It is asked on a timer rather than
// on every render, and only when the person can reach the page it warns about. `toFlag` reads the answer.
function usePolledFlag(path, enabled, toFlag) {
  const [flag, setFlag] = useState(false);
  useEffect(() => {
    if (!enabled) { setFlag(false); return undefined; }
    let cancelled = false;
    const ask = () => apiGet(path).then((res) => { if (!cancelled) setFlag(toFlag(res)); }).catch(() => {});
    ask();
    const timer = setInterval(ask, ASK_EVERY_MS);
    return () => { cancelled = true; clearInterval(timer); };
  }, [path, enabled, toFlag]);
  return flag;
}

const anyIntegrationDown = (res) => Boolean(res?.any_down);
// The count endpoint returns a bare number, not the documents: a dot should not pull file names across the wire.
const hasPendingIds = (res) => (res?.pending || 0) > 0;
const needsCalendarReconnect = (rows) => (Array.isArray(rows) ? rows : []).some((row) =>
  row?.provider === "google" && row?.calendar_email && row?.sync_status !== "connected");

// The red dots and the red row in the sidebar (the `alert` and `urgent` names in navigation.js).
export function useNavFlags(data) {
  const me = data.me;
  // A delay still marked Active turns Delay Management red. "delays" is kept live by the app's own load, so no poll.
  const activeDelay = (data.delays || []).some((d) => d.status === "Active");
  return {
    activeDelay,
    integrationsDown: usePolledFlag("/Users/admin-panel/integrations-health/", runsCompany(me), anyIntegrationDown),
    idsWaiting: usePolledFlag("/MainApp/joining-reviews/count", canSeeLabel(me, "IDs Waiting"), hasPendingIds),
    calendarReconnect: usePolledFlag("/Banao/calendar/connections/mine/", true, needsCalendarReconnect),
  };
}
